export function initializedPromise(callback, errorString, intervalInMs, times) {
    let count = 0;
    function checkIfLoaded(resolve, reject) {
        if (count === times) {
            reject(errorString);
            return;
        }
        if (callback()) {
            resolve();
        }
        else {
            count += 1;
            setTimeout(() => checkIfLoaded(resolve, reject), intervalInMs);
        }
    }
    return new Promise((resolve, reject) => {
        checkIfLoaded(resolve, reject);
    });
}
